import { removeRecentCity as removeRecentCityAction } from 'app/store/reducers/location';
import { recentCitiesCookieSelector, recentCitiesSelector } from 'app/store/selectors';
import { ThunkType } from 'app/hooks/appHooks';
import { SearchMaskDirection } from 'app/models/types/store/location';
import { setCookieForDomain } from 'app/functions/general/setCookieForDomain';

export type RemoveRecentCityType = {
  direction: SearchMaskDirection;
  cityId: string;
};

export const removeRecentCity =
  ({ direction, cityId }: RemoveRecentCityType): ThunkType<void> =>
  (dispatch, getState) => {
    dispatch(removeRecentCityAction({ direction, cityId }));

    const state = getState();
    const cookies: { from: string; to: string } = recentCitiesCookieSelector(state);
    const recentCities: ReturnType<typeof recentCitiesSelector> = recentCitiesSelector(state);
    setCookieForDomain({
      cookieName: cookies[direction],
      cookieValue: JSON.stringify(recentCities[direction]),
    });
  };
